import React from 'react'

const RELOAD_KEY = 'chunk-reload'

/**
 * Lazily loaded route page. After a deploy the old chunk files are gone, so a tab opened before it fails to
 * load them: reload once to pick up the new build instead of showing an error.
 */
export const lazyPage = <T extends React.ComponentType<any>>(load: () => Promise<{ default: T }>) =>
  React.lazy(() =>
    load().then(
      module => {
        try {
          sessionStorage.removeItem(RELOAD_KEY)
        } catch {
          // Storage unavailable, nothing to reset
        }
        return module
      },
      error => {
        try {
          if (!sessionStorage.getItem(RELOAD_KEY)) {
            sessionStorage.setItem(RELOAD_KEY, '1')
            window.location.reload()
            // Keep suspending until the reload replaces the page
            return new Promise<never>(() => {
              // never settles
            })
          }
        } catch {
          // Storage unavailable, fall through to the error boundary
        }
        throw error
      }
    )
  )
